'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDateTimeDefaultValue;
function getDateTimeDefaultValue() {
    return new Date('0001-01-01T00:00:00').getTime();
}